import { IBlogPost } from '../types/blogPost'
import Container from './container'
import MainContent from './MainContent'
import BlogSidebar from './BlogSidebar'
import SectionHero from './SectionHero'
import GoToTop from './GoToTop'
import ShareButtons from './share-buttons'
import { root, grid } from './BlogPost.module.css'

function BlogPost({
  excerpt,
  _rawBody,
  authors,
  categories,
  title,
  publishedAt,
  updatedOn,
  url,
}: IBlogPost) {
  /* The Main (first) image is extracted and moved to the top for design purposes. The rest of the content is displayed below it. */
  const topImage =
    _rawBody && _rawBody.find((item) => item?._type === 'mainImage')
  const content = _rawBody && _rawBody.filter((element) => element !== topImage)

  return (
    <article className={root}>
      <SectionHero title={title} />
      <Container extraClass={grid}>
        <div>
          <MainContent
            topImage={topImage}
            publishedAt={publishedAt}
            updatedOn={updatedOn}
            categories={categories}
            authors={authors}
            excerpt={excerpt}
            content={content}
          />
          <div className="mb-8 mt-16 flex flex-col items-center gap-4">
            <p className="text-center font-bold">Share</p>
            <ShareButtons title={title} url={url} />
          </div>
        </div>
        <BlogSidebar category={categories?.[0]} />
      </Container>
      <GoToTop />
    </article>
  )
}

export default BlogPost
